import React, { FormEvent, useState } from 'react'
import { Link } from 'react-router-dom'

import { Record } from '../../../models'
import { UpdateRecordParams } from '../../../api'

interface FormProps {
    handleSubmit: (e: FormEvent<HTMLFormElement>, inputs: UpdateRecordParams) => void
    record?: Record
}

export const RecordRefundForm = ({ handleSubmit, record }: FormProps) => {
    const defaultInputs: UpdateRecordParams = {
        refund_support_link: record?.refundSupportLink || '',
    }

    const [inputs, setInputs] = useState(defaultInputs)

    const updateInputs = (field: keyof UpdateRecordParams, value: string | number) => {
        setInputs({
            ...inputs,
            [field]: value,
        })
    }

    if (!record) return null

    return (
        <form onSubmit={(e) => handleSubmit(e, inputs)}>
            <table className="table">
                <tbody>
                    <tr>
                        <th>Record ID</th>
                        <td>{record.id}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td>{record.status.name}</td>
                    </tr>
                    <tr>
                        <th>Agency</th>
                        <td>
                            <Link to={`/agencies/${record.agency.id}`} className="text-nowrap">
                                {record.agency.name}
                            </Link>
                        </td>
                    </tr>
                    <tr>
                        <th>First Name</th>
                        <td>{record.guestFirstName}</td>
                    </tr>
                    <tr>
                        <th>Last Name</th>
                        <td>{record.guestLastName}</td>
                    </tr>
                    <tr>
                        <th>Confirmation Number</th>
                        <td>{record.confirmationNumber}</td>
                    </tr>
                    <tr>
                        <th>Refund Support Link</th>
                        <td>
                            <input
                                type="url"
                                className="form-control"
                                id="refundSupportLinkInput"
                                placeholder="Enter Google Drive link"
                                value={inputs.refund_support_link || ''}
                                onChange={(e) =>
                                    updateInputs('refund_support_link', e.target.value)
                                }
                                required
                            />
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="row mb-5">
                <div className="col-12 d-flex justify-content-center">
                    <button className="btn btn-primary" type="submit">
                        Save Changes
                    </button>
                </div>
            </div>
        </form>
    )
}
